<ng-template>
    <section #popupComponent>
      <div class="triangle-up"></div>
      <section class="popup-container">
      <h2>
        <i class="material-icons notranslate">playlist_play</i>
        Chained rule groups
      </h2>
      <ul id="chained-rule-groups" class="scrollable-container">
        <li *ngFor="let chain of ruleChainsDataService.allChains; let i = index">
          <app-rule-chain
            [chainData]="getChainComplexData(chain.id)"
            [savedChainEvent]="savedChainEvent"
            [onChainDeleted]="onChainDeleted.bind(this)"
            [parentGetViewState]="getViewState.bind(this)"
            [parentSetViewState]="setViewState.bind(this)"
            [navigateToDataRules]="navigateToDataRules"
            (chainClickedEventEmitter)="onChainClicked(chain.id)"
          ></app-rule-chain>
        </li>
        <li *ngIf="ruleChainsDataService.allChains.length === 0" class="no-results">
          No chained rule groups, please create one below
        </li>
      </ul>
      <button (click)="addNewChain()" #focusElement>
        New Chained Group
        <i class="material-icons notranslate">playlist_add</i>
      </button>
    </section>
  </section>
</ng-template>
